const brandStoryTileCopy = {
  link: 'Read More',
  postedBy: 'Posted by',
};

export default brandStoryTileCopy;
